import script from "./uploadLicenseForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./uploadLicenseForm.vue?vue&type=script&lang=ts&setup=true"

import "./uploadLicenseForm.vue?vue&type=style&index=0&id=669dcee3&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-669dcee3"]])

export default __exports__